"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _typeof = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/typeof.js");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _tradeBanner = _interopRequireDefault(require("../../components/trade/trade-banner.vue"));
var _rightNav = _interopRequireDefault(require("../../components/trade/right-nav.vue"));
var _appCitysData = _interopRequireDefault(require("@/assets/static/js/citys/app.citys.data.js"));
var _footNav = _interopRequireDefault(require("../../components/foot-nav"));
var _api = _interopRequireWildcard(require("../../api/api"));
var _relativeTime = require("../../assets/static/js/utils/relativeTime.js");
var _cookie = require("@/assets/static/js/utils/cookie.js");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var _default = exports.default = {
  name: 'pubgoods',
  components: {
    tradeBanner: _tradeBanner.default,
    rightNav: _rightNav.default,
    footNav: _footNav.default
  },
  data: function data() {
    var _this = this;
    // 参考价格校验
    var priceRule = function priceRule(rule, value, callback) {
      if (value != '' && parseInt(value) < parseInt(_this.pubForm.gsData.minPrice)) {
        callback(new Error('请输入正确的参考价格'));
      } else {
        callback();
      }
    };
    return {
      clength: ['4.2', '6.2', '7.2', '9.6', '13', '16', '17'],
      //车辆长度数据,
      gtType: [],
      ctType: [],
      handingway: [],
      useVcType: [],
      // isempty: Boolean, //控制发布按钮
      pubForm: {
        gsData: {
          startLocation: [],
          //起始地
          endLocation: [],
          //目的地
          contact: '',
          //联系人
          phone: '',
          //联系电话
          goodsName: '',
          //货物名称
          gtid: '',
          //货物类型
          goodsWeigth: '',
          //货物重量
          useVcType: '',
          //运输类型
          vehicleTypeId: '',
          //所需车型
          arrivalTime: '',
          //装车时间
          loadSourceCode: '',
          //装卸方式
          margin: '',
          //保证金
          remark: '',
          //备注
          minPrice: null,
          //参考价格-最低
          topPrice: null,
          //参考价格-最高
          gsTop: 'false',
          //是否置顶
          sourceTypeId: '4' //来源类型(固定4)
        }
      },
      // 表单校验
      pubRules: {
        gsData: {
          startLocation: [{
            required: true,
            message: '请选择出发城市',
            trigger: 'change'
          }],
          endLocation: [{
            required: true,
            message: '请选择到达城市'
          }],
          contact: [{
            required: true,
            message: '请填写联系人',
            trigger: 'blur'
          }],
          phone: [{
            required: true,
            message: '请输入联系电话',
            trigger: 'blur'
          }, {
            pattern: /^1\d{10}$/,
            message: '请输入正确的手机号',
            trigger: 'blur'
          }],
          goodsName: [{
            required: true,
            message: '请输入货物名称',
            trigger: 'blur'
          }, {
            max: 10,
            message: '最多只能输入10个字符',
            trigger: 'blur'
          }],
          gtid: [{
            required: true,
            message: '请选择货物类型',
            trigger: 'change'
          }],
          goodsWeigth: [{
            required: true,
            message: '请输入货物重量',
            trigger: 'blur'
          }],
          vehicleTypeId: [{
            required: true,
            message: '请选择所需车型',
            trigger: 'change'
          }],
          topPrice: [{
            validator: priceRule,
            trigger: 'blur'
          }],
          arrivalTime: [{
            required: true,
            message: '请选择装车时间',
            trigger: 'change'
          }]
        }
      },
      //表单校验
      start: '',
      end: '',
      startCitys: _appCitysData.default.cityData,
      //出发城市数据
      endCitys: _appCitysData.default.cityData,
      //出发城市数据
      rightAdverData: [],
      //右侧广告

      tabList: [{
        name: '货源查询',
        url: 'goods'
      }, {
        name: '车源查询',
        url: 'cars'
      }, {
        name: '发布车源',
        url: 'pubcars'
      }, {
        name: '发布货源',
        url: 'pubgoods'
      }]
    };
  },
  computed: {
    isempty: {
      get: function get() {
        var that = this,
          flag = true;
        if (that.pubForm.gsData.startLocation.length > 0 && that.pubForm.gsData.endLocation.length > 0 && that.pubForm.gsData.contact && that.pubForm.gsData.phone && that.pubForm.gsData.goodsName && that.pubForm.gsData.gtid && that.pubForm.gsData.goodsWeigth && that.pubForm.gsData.vehicleTypeId && that.pubForm.gsData.arrivalTime) {
          flag = false;
        }
        return flag;
      },
      // 表单验证时候,有对这个计算属性直接赋值的操作.不写set,会报错
      // 因为vue的计算属性默认有get,没有set
      set: function set(newValue) {
        return newValue;
      }
    }
  },
  created: function created() {
    this.toLogin();
    // 表单内容的回填
    if (sessionStorage.getItem('pubGoodsForm')) Object.assign(this.pubForm, JSON.parse(sessionStorage.getItem('pubGoodsForm')));
    this.loadAdvertiseData(); //右侧广告
    this.getGoodsType(); //货物类型
    this.getCarType(); //货物类型
    this.getUseVcType(); //承接类型
    this.getLoadSourceCode(); //装卸方式
  },
  beforeRouteLeave: function beforeRouteLeave(to, form, next) {
    // 页面离开前将缓存清除,以免影响下次的发布货源
    sessionStorage.removeItem('pubGoodsForm');
    next();
  },
  methods: {
    //获取广告
    loadAdvertiseData: function () {
      var _loadAdvertiseData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that, userInfo, _yield$Api$apiGetAdve, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              that = this; // session替换成cookie
              userInfo = (0, _cookie.getCookie)('user') ? JSON.parse((0, _cookie.getCookie)('user')) : ''; // var userInfo = JSON.parse(window.sessionStorage.getItem('user'))
              _context.next = 4;
              return _api.default.apiGetAdvertiseData({
                showType: 'PC_GS_RELEASE',
                userId: userInfo ? userInfo.usid : ''
              });
            case 4:
              _yield$Api$apiGetAdve = _context.sent;
              data = _yield$Api$apiGetAdve.data;
              that.rightAdverData = data.proData.filter(function (item) {
                return item.showPosition != 'CENTER';
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadAdvertiseData() {
        return _loadAdvertiseData.apply(this, arguments);
      }
      return loadAdvertiseData;
    }(),
    //选择出发城市
    startCityChange: function startCityChange(value) {
      var that = this;
      if (value.length > 0 && (value[0].indexOf('台湾') >= 0 || value[0].indexOf('香港特别行政区') >= 0 || value[0].indexOf('澳门特别行政区') >= 0 || value[0].indexOf('钓鱼岛') >= 0)) {
        that.$message({
          message: '该地区业务还未开展',
          type: 'warning'
        });
        that.pubForm.gsData.startLocation = [];
        value = [];
        return;
      }
      var startStr = value.join('/');
      that.start = startStr.replace(/\/全省/g, '');
      that.start = startStr.replace(/\/全市/g, '');
    },
    //选择到达城市
    endCityChange: function endCityChange(value) {
      var that = this;
      if (value.length > 0 && (value[0].indexOf('台湾') >= 0 || value[0].indexOf('香港特别行政区') >= 0 || value[0].indexOf('澳门特别行政区') >= 0 || value[0].indexOf('钓鱼岛') >= 0)) {
        that.$message({
          message: '该地区业务还未开展',
          type: 'warning'
        });
        that.pubForm.gsData.endLocation = [];
        value = [];
        return;
      }
      var endStr = value.join('/');
      that.end = endStr.replace(/\/全省/g, '');
      that.end = endStr.replace(/\/全市/g, '');
    },
    // 获取货物类型
    getGoodsType: function () {
      var _getGoodsType = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that, _yield$Api$apiGetGood, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              that = this;
              _context2.next = 3;
              return _api.default.apiGetGoodsTypeData();
            case 3:
              _yield$Api$apiGetGood = _context2.sent;
              data = _yield$Api$apiGetGood.data;
              if (data.proCode == '200') {
                that.gtType = data.proData;
              } else {
                //  console.log(data.proMsg)
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getGoodsType() {
        return _getGoodsType.apply(this, arguments);
      }
      return getGoodsType;
    }(),
    // 获取车辆类型
    getCarType: function () {
      var _getCarType = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that, _yield$Api$apiGetCarT, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              that = this;
              _context3.next = 3;
              return _api.default.apiGetCarTypeData();
            case 3:
              _yield$Api$apiGetCarT = _context3.sent;
              data = _yield$Api$apiGetCarT.data;
              if (data.proCode == '200') {
                that.ctType = data.proData;
                that.ctType = that.ctType.filter(function (item) {
                  if (item.vehicleTypeName != '不限') {
                    return item;
                  }
                });
              } else {
                //  console.log(data.proMsg)
              }
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getCarType() {
        return _getCarType.apply(this, arguments);
      }
      return getCarType;
    }(),
    // 获取装卸方式
    getLoadSourceCode: function () {
      var _getLoadSourceCode = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that, param, _yield$Api$apiGetDicD, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              that = this;
              param = {
                dicttypekey: "LOAD_SOURCE_CODE"
              };
              _context4.next = 4;
              return _api.default.apiGetDicData(param);
            case 4:
              _yield$Api$apiGetDicD = _context4.sent;
              data = _yield$Api$apiGetDicD.data;
              if (data.code == '200') {
                that.handingway = data.datalist;
              } else {
                //  console.log(data.msg)
              }
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getLoadSourceCode() {
        return _getLoadSourceCode.apply(this, arguments);
      }
      return getLoadSourceCode;
    }(),
    // 获取运输类型
    getUseVcType: function () {
      var _getUseVcType = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that, param, _yield$Api$apiGetDicD2, data;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              that = this;
              param = {
                dicttypekey: "USE_VC_TYPE"
              };
              _context5.next = 4;
              return _api.default.apiGetDicData(param);
            case 4:
              _yield$Api$apiGetDicD2 = _context5.sent;
              data = _yield$Api$apiGetDicD2.data;
              if (data.code == '200') {
                that.useVcType = data.datalist;
              } else {
                //  console.log(data.msg)
              }
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getUseVcType() {
        return _getUseVcType.apply(this, arguments);
      }
      return getUseVcType;
    }(),
    // 立即发布
    topubgoods: function topubgoods(formName) {
      var _this2 = this;
      // session替换成cookie
      var userStorage = (0, _cookie.getCookie)('user');
      var userToken = (0, _cookie.getCookie)('token');
      // let userStorage = window.sessionStorage.getItem('user')
      if (!userStorage || !userToken) {
        // 为解决发布时再登录的情况下,页面刷新导致的表单内容丢失问题
        sessionStorage.setItem('pubGoodsForm', JSON.stringify(this.pubForm));
        this.$root.dialogFormVisible = true;
      } else {
        var goodsParam = JSON.parse(JSON.stringify(this.pubForm.gsData));
        this.$refs[formName].validate(function (valid) {
          if (!valid) {
            return false;
          } else {
            goodsParam.startLocation = goodsParam.startLocation.join('/');
            goodsParam.endLocation = goodsParam.endLocation.join('/');
            goodsParam.startLocation = goodsParam.startLocation.replace(/\/全省/g, '');
            goodsParam.startLocation = goodsParam.startLocation.replace(/\/全市/g, '');
            goodsParam.endLocation = goodsParam.endLocation.replace(/\/全省/g, '');
            goodsParam.endLocation = goodsParam.endLocation.replace(/\/全市/g, '');
            goodsParam.arrivalTime = (0, _relativeTime.formatDate)(goodsParam.arrivalTime, 'yyyy/MM/dd hh:mm:ss');
            if (goodsParam.loadSourceCode) {
              _this2.handingway.filter(function (item) {
                if (item.defineCode == goodsParam.loadSourceCode) {
                  goodsParam.remark = item.defineValue + ';' + goodsParam.remark;
                }
              });
            }
            if (goodsParam.useVcType) {
              _this2.useVcType.filter(function (item) {
                if (item.defineCode == goodsParam.useVcType) {
                  goodsParam.remark = item.defineValue + ';' + goodsParam.remark;
                }
              });
            }
            var params = {
              jsondata: JSON.stringify(goodsParam)
            };
            var paramete = {
              "version": '1',
              "fun": 'releasepcgs',
              "param": params
            };
            var jsonParamete = {
              jsonParamete: JSON.stringify(paramete)
            };
            _this2.pushGoods(jsonParamete);
          }
        });
      }
    },
    pushGoods: function () {
      var _pushGoods = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(param) {
        var _yield$apiGetPubGoods, data;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return (0, _api.apiGetPubGoodsData)(param);
            case 2:
              _yield$apiGetPubGoods = _context6.sent;
              data = _yield$apiGetPubGoods.data;
              if (data.proCode == '200') {
                this.$router.push({
                  name: 'pubgoodsucceed',
                  query: {
                    gsid: data.proData.gsid
                  }
                });
              } else if (data.proCode == '250') {
                this.$message({
                  message: data.proMsg,
                  type: 'error',
                  duration: '1000'
                });
              } else {
                this.$message({
                  message: '发布失败,请重试!',
                  type: 'error',
                  duration: '1000'
                });
              }
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function pushGoods(_x) {
        return _pushGoods.apply(this, arguments);
      }
      return pushGoods;
    }(),
    // 未登录弹出登录窗
    toLogin: function toLogin() {
      var that = this;
      // session替换成cookie
      var userStorage = (0, _cookie.getCookie)('user');
      // let userStorage = window.sessionStorage.getItem('user')
      if (!userStorage) {
        that.$root.dialogFormVisible = true;
      }
    },
    // 判断表单是否填写完整
    canPub: function canPub() {
      var that = this;
      if (that.pubForm.gsData.startLocation.length > 0 && that.pubForm.gsData.endLocation.length > 0 && that.pubForm.gsData.contact && that.pubForm.gsData.phone && that.pubForm.gsData.goodsName && that.pubForm.gsData.gtid && that.pubForm.gsData.goodsWeigth && that.pubForm.gsData.vehicleTypeId && that.pubForm.gsData.arrivalTime) {
        that.isempty = false;
      } else {
        that.isempty = true;
      }
    },
    tabChange: function tabChange(url) {
      this.$router.push({
        name: url
      });
    }
  }
};